import { memo } from "react";

export type FilterIconProps = {
  width?: number;
  height?: number;
  color?: string;
  title?: string;
};

const FilterIcon = ({ width = 24, height = 24, color = "#FF9933", title }: FilterIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    aria-label={title}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M3 17V19H9V17H3ZM3 5V7H13V5H3ZM13 21V19H21V17H13V15H11V21H13ZM7 9V11H3V13H7V15H9V9H7ZM21 13V11H11V13H21ZM15 9H17V7H21V5H17V3H15V9Z"
      fill={color}
    />
  </svg>
);

export default memo(FilterIcon);
